<!-- -->
<template>
  <div :class="{ frame: true, 'm-frame': isMobile }">
    <div id="banner">
      <div class="swiper-wrapper">
        <div class="swiper-slide">
          <img
            :src="URL + '/static/banner_mission.jpg'"
            alt=""
            class="banner"
          />
        </div>
        <div class="swiper-slide">
          <img :src="URL + '/static/banner_vision.jpg'" alt="" class="banner" />
        </div>
        <div class="swiper-slide">
          <img :src="URL + '/static/banner_value.jpg'" alt="" class="banner" />
        </div>
      </div>
      <div class="swiper-pagination"></div>
    </div>
    <div class="box">
      <img
        src="http://gxbg.pangodso.com/file/static/intro_bg2.jpg"
        alt=""
        class="bg"
      />
      <div class="title-box">
        <div class="title">企业介绍</div>
      </div>
      <div class="intro">
        <p>
          广西盘古百桂广告有限公司（简称广西盘古）为盘古广告旗下子公司，于2024年4月应市场发展之需在广西正式成立。
        </p>
        <p>
          广西盘古秉承盘古广告品牌愿景，致力于成为一家顶尖的互联网专业服务商并永续发展，成为一家勇于承担社会责任并有人情味的企业。目前，公司与国内知名互联网公司达成深度合作，成为百度公司广西南宁地区的独家代理商、深度云海广西地区代理商。同时，广西盘古持续拓展业务版图，精进专业能力与服务品质，着力塑造卓越服务品牌与企业形象，在客户群体中树立了良好口碑与广泛知名度。
        </p>
      </div>
      <div class="imgs">
        <!-- <div class="left">
          <img style="width: 487px" :src="URL + 'envir1.jpg'" />
          <img
            style="width: 318px; margin-left: 20px"
            :src="URL + 'envir2.jpg'"
          />
          <img
            style="width: 566px; margin-top: 20px"
            :src="URL + 'envir5.jpg'"
          />
          <img
            style="width: 239px; margin-left: 20px; margin-top: 20px"
            :src="URL + 'envir4.jpg'"
          />
        </div>
        <img
          style="width: 360px"
          :src="URL + 'envir3.jpg'"
          alt=""
          class="right"
        /> -->
        <el-row :gutter="10">
          <el-col v-for="(item, index) in envirImgs" :span="8" :key="index">
            <div style="position: relative; width: 100%">
              <el-image
                :src="URL + item"
                fit="cover"
                style="width: 100%"
              ></el-image>

              <img
                :src="URL + 'static/intro-logo.png'"
                style="
                  position: absolute;
                  right: 8px;
                  bottom: 8px;
                  width: 5rem;
                  object-fit: contain;
                  z-index: 10;
                "
                alt="logo"
              />
            </div>
          </el-col>
        </el-row>
      </div>
    </div>
    <div class="power" ref="powerRef">
      <div class="title-box">
        <div class="title">集团实力</div>
      </div>
      <div class="content">
        <div class="item">
          <div class="count">
            <countTo
              ref="count1"
              :startVal="0"
              :endVal="yearNum"
              :duration="3000"
              :autoplay="false"
              separator=""
            ></countTo>
            年
          </div>
          <div class="type">广告经验</div>
        </div>
        <div class="item">
          <div class="count">
            <countTo
              ref="count2"
              :startVal="0"
              :endVal="teamNum"
              :duration="3000"
              :autoplay="false"
              separator=""
            ></countTo>
            <span class="topUnit">+</span>
            人
          </div>
          <div class="type">服务团队</div>
        </div>
        <div class="item">
          <div class="count">
            <countTo
              ref="count3"
              :startVal="0"
              :endVal="memberNum"
              :duration="3000"
              :autoplay="false"
              separator=""
            ></countTo>
            <span class="topUnit">+</span>
          </div>
          <div class="type">合作客户</div>
        </div>
        <div class="item">
          <div class="count">
            <countTo
              ref="count4"
              :startVal="0"
              :endVal="areaNum"
              :duration="3000"
              :autoplay="false"
              separator=""
            ></countTo>
            <span class="topUnit">+</span>
            ㎡
          </div>
          <div class="type">甲级写字楼</div>
        </div>
        <div class="dot"></div>
      </div>
    </div>
    <div class="cert">
      <img :src="URL + '/static/cert_bg.jpg'" alt="" class="cert-bg" />
      <div class="in">
        <div class="title-box">
          <div class="title">企业资质</div>
        </div>
      </div>
      <div class="cert-imgs">
        <imageSlider />
      </div>
    </div>
    <div class="value">
      <div class="in">
        <div class="left">
          <div
            :class="{ tab: true, active: activeTab == 0 }"
            @mouseenter="changeTab(0)"
          >
            <span>企业<br />使命</span>
            <img src="@/assets/value_icon.png" alt="" class="icon" />
          </div>
          <div
            :class="{ tab: true, active: activeTab == 1 }"
            @mouseenter="changeTab(1)"
          >
            <span>企业<br />愿景</span>
            <img src="@/assets/value_icon.png" alt="" class="icon" />
          </div>
          <div
            :class="{ tab: true, active: activeTab == 2 }"
            @mouseenter="changeTab(2)"
          >
            <span>企业<br />价值观</span>
            <img src="@/assets/value_icon.png" alt="" class="icon" />
          </div>
        </div>
        <div class="right">
          <div class="tab_content" v-show="activeTab == 0">
            <div class="title">我们的使命</div>
            <div class="sub">助力客户事业发展<br />成就员工人生价值</div>
          </div>
          <div class="tab_content" v-show="activeTab == 1">
            <div class="title">我们的愿景</div>
            <div class="sub">
              成为一家顶尖的互联网广告服务商并永续发展<br />成为一家勇于承担社会责任并有人情味的企业
            </div>
          </div>
          <div class="tab_content" v-show="activeTab == 2">
            <div class="title">我们的价值观</div>
            <div class="sub">
              正直诚信 敬业乐群 悦纳变化<br />令行禁止 只做第一 使命必达
            </div>
          </div>
        </div>
      </div>
    </div>
    <submit v-if="!isMobile" />
  </div>
</template>

<script>
import countTo from "vue-count-to";
import submit from "@/components/submit.vue";
import imageSlider from "@/components/imageSlider.vue";
import { URL } from "@/util/config";
import { Store } from "@/store/index.js";
import { mapState } from "pinia";

export default {
  components: { countTo, submit, imageSlider },
  data() {
    return {
      URL,
      teamNum: 300,
      yearNum: 22,
      areaNum: 7900,
      memberNum: 50000,
      activeTab: 0, // 激活的使命价值观下标
      envirImgs: [
        "envir1.jpg",
        "envir2.jpg",
        "envir3.jpg",
        "envir4.jpg",
        "envir5.jpg",
        "envir6.jpg",
      ],
    };
  },
  computed: {
    ...mapState(Store, ["isMobile"]),
  },
  mounted() {
    this.initBanner();
    this.initYearNum();
    this.$nextTick(() => {
      this.observerDom();
    });
  },
  beforeDestroy() {
    if (this.ob) {
      this.ob.disconnect();
      this.ob = null;
    }
    if (this.countTimer) {
      clearTimeout(this.countTimer);
      this.countTimer = null;
    }
  },
  methods: {
    initYearNum() {
      this.yearNum = new Date().getFullYear() - 2003;
    },
    initBanner() {
      new window.Swiper("#banner", {
        loop: true,
        autoplay: true,
        pagination: {
          el: "#banner .swiper-pagination",
        },
      });
    },
    changeTab(idx) {
      this.activeTab = idx;
    },
    // 监听页面滚动事件
    observerDom() {
      const box = this.$refs.powerRef;
      if (!box) return;
      this.ob = new IntersectionObserver((entries) => {
        if (entries[0].isIntersecting) {
          this.countTimer = setTimeout(() => {
            this.numIncrease();
          }, 600);
          this.ob.unobserve(box);
        }
      });
      this.ob.observe(box);
    },
    // 企业规模数字增长函数
    numIncrease() {
      this.$nextTick(() => {
        ["count1", "count2", "count3", "count4"].forEach((ref) => {
          const counter = this.$refs[ref];
          if (counter && typeof counter.start === "function") {
            counter.start();
          }
        });
      });
    },
  },
};
</script>

<style lang="scss" scoped>
$-width: 1200px;
#banner {
  width: 100%;
  overflow: hidden;
  position: relative;

  .banner {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
}
.title-box {
  text-align: center;
  position: relative;
  z-index: 2;

  &::after {
    content: "";
    display: block;
    width: 70px;
    height: 4px;
    background-color: $theme;
    margin: 20px auto 0;
  }
  .title {
    font-size: 40px;
    color: $theme;
  }
}
.box {
  padding: 60px 0 40px;
  position: relative;

  .bg {
    width: 100%;
    height: 518px;
    object-fit: cover;
    position: absolute;
    top: 110px;
    z-index: 1;
  }
  .intro {
    width: $-width;
    margin: 60px auto 0;
    line-height: 36px;
    font-size: 19px;
    text-indent: 2em;
    position: relative;
    z-index: 2;
  }
  .imgs {
    width: $-width;
    margin: 290px auto 0;
    display: flex;
    position: relative;
    z-index: 2;

    .left {
      display: flex;
      flex-wrap: wrap;
    }
  }
}
.cert {
  position: relative;

  .cert-bg {
    width: 100%;
    min-height: 1063px;
    object-fit: cover;
    display: block;
  }
  .in {
    width: 100%;
    height: 100%;
    position: absolute;
    left: 0;
    top: 0;
    padding: 100px 0 70px;
  }
  .cert-imgs {
    display: none;
  }
}
.value {
  height: 590px;
  background-image: url("http://gxbg.pangodso.com/file/static/value_bg.png");
  background-size: cover;
  background-position-x: center;

  .in {
    width: $-width;
    height: 100%;
    margin: 0 auto;
    display: flex;
    align-items: center;

    .left {
      width: 223px;
      height: 100%;
      display: flex;
      flex-direction: column;

      .tab {
        flex: 1;
        padding: 25px;
        box-sizing: border-box;
        display: flex;
        align-items: center;
        justify-content: space-between;
        background-color: rgba($color: #000, $alpha: 0.5);
        cursor: pointer;

        span {
          color: #fff;
          font-size: 30px;
        }
        .icon {
          width: 27px;
        }
      }
      .active {
        background-color: rgba($color: $theme, $alpha: 0.5);
      }
    }
    .right {
      flex-grow: 1;
      margin-left: 90px;

      .tab_content {
        color: #fff;
        animation: fadeIn 0.5s;

        .title {
          font-size: 30px;
          margin-bottom: 20px;
        }
        .sub {
          font-size: 40px;
          margin-bottom: 32px;
          font-weight: bold;
        }
        .about {
          width: 180px;
          height: 40px;
          color: #fff;
          font-size: 18px;
          background-color: $theme;
        }
      }
    }
  }
}
.power {
  padding: 30px 0 50px;
  box-shadow: 0 10px 16px rgba($color: #0454d8, $alpha: 0.11);
  position: relative;
  z-index: 2;

  .content {
    width: $-width;
    height: 75px;
    margin: 80px auto 0;
    display: flex;

    .dot {
      width: 4px;
      height: 4px;
      background-color: $theme;
      border-radius: 50%;
      position: absolute;
      left: 50%;
      top: 50%;
      transform: translate(-50%, -50%);
      display: none;
    }
    .item {
      flex: 1;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;

      &:not(:first-child) {
        border-left: 3px solid $theme;
      }
      .count {
        font-size: 21px;

        span {
          color: $theme;
          font-size: 58px;
          font-weight: bold;
        }
        .topUnit {
          vertical-align: top;
          font-size: 22px;
          color: #000;
        }
      }
      .type {
        font-size: 18px;
      }
    }
  }
}

.m-frame {
  #banner .banner {
    height: 165px;
  }
  .title-box {
    &::after {
      content: "";
      width: 50px;
      height: 2px;
      margin-top: 10px;
    }
    .title {
      font-size: 25px;
      font-weight: bold;
    }
  }
  .box {
    padding: 40px 0;

    .bg {
      height: 130px;
      top: 40%;
    }
    .intro {
      width: 100%;
      margin: 20px 0 0 0;
      padding: 0 10px;
      box-sizing: border-box;
      font-size: 14px;
      line-height: 1.5;
      text-align: justify;
    }
    .imgs {
      width: 100%;
      margin: 60px 0 0 0;
      padding: 0 10px;
      box-sizing: border-box;

      .left {
        img {
          &:first-child {
            width: 55% !important;
          }
          &:nth-child(2) {
            width: 37% !important;
            margin-left: 10px !important;
          }
          &:nth-child(3) {
            width: 60% !important;
            margin-top: 10px !important;
          }
          &:nth-child(4) {
            width: 32% !important;
            margin-top: 10px !important;
            margin-left: 10px !important;
          }
        }
      }
      .right {
        width: 28% !important;
      }
    }
  }
  .power {
    padding: 10px 0 40px;

    .content {
      width: 100%;
      height: auto;
      margin-top: 40px;
      flex-wrap: wrap;
      position: relative;

      &::after,
      &::before {
        content: "";
        display: block;
        position: absolute;
        left: 50%;
        top: 50%;
        transform: translate(-50%, -50%);
      }
      &::before {
        width: 90%;
        height: 0;
        border-bottom: 1px solid $theme;
      }
      &::after {
        width: 0;
        height: 100%;
        border-right: 1px solid $theme;
      }
      .dot {
        display: block;
      }
      .item {
        width: 50%;
        padding: 10px 0;
        box-sizing: border-box;
        flex: unset;
        border-left: none;

        .count {
          font-size: 18px;

          span {
            font-size: 33px;
          }
          .topUnit {
            font-size: 18px;
          }
        }
        .type {
          font-size: 16px;
        }
      }
    }
  }
  .cert {
    .cert-bg {
      display: none;
    }
    .cert-imgs {
      display: block;
      width: 100%;
      padding-top: 120px;
      overflow: auto;
      display: flex;

      .cert-img {
        width: 80%;
        flex-shrink: 0;

        & + .cert-img {
          margin-left: 2px;
        }
      }
    }
    .in {
      height: auto;
      padding: 40px 0 20px;
      box-sizing: border-box;
    }
  }
  .value {
    height: 260px;

    .in {
      width: 100%;
      flex-direction: column;

      .left {
        width: 100%;
        height: unset;
        flex-direction: row;

        .tab {
          height: 110px;
          text-align: center;
          padding: 10px;
          flex-direction: column;

          span {
            font-size: 18px;
          }
          .icon {
            width: 20px;
            transform: rotate(90deg);
          }
        }
      }
      .right {
        margin-left: 0;
        margin-top: 20px;
        flex-grow: unset;

        .tab_content {
          width: fit-content;

          .title {
            font-size: 16px;
            margin-bottom: 10px;
          }
          .sub {
            font-size: 16px;
            margin-bottom: 20px;
          }
          .about {
            width: 120px;
            height: 30px;
            font-size: 14px;
          }
        }
      }
    }
  }
}
</style>
